import { orderDetailsPath } from '@/constants/routes';

const CALLBACK_TYPE = 'CALLBACK';

export const isCallbackError = (error) => error.type === CALLBACK_TYPE;

export const getErrorTarget = (error) => {
    if (isCallbackError(error)) {
        return error.entity_id ? orderDetailsPath(error.entity_id) : null;
    }

    return error.integration?.job_id ? `/job/${error.integration.job_id}` : null;
};
